import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MessageDeliveryExceptionService from "../../src/Services/MessageDeliveryException.service";
const MessageDeliveryExceptionLookup = (props) => {
    return LookupGeneric({
        valueKey: "code",
        labelKey: "name",
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return MessageDeliveryExceptionService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MessageDeliveryExceptionService.searchAll(search);
        },
        optionRenderer: function optionRenderer(messageDeliveryException) {
            return _jsx("span", { children: messageDeliveryException.name });
        },
    });
};
export default MessageDeliveryExceptionLookup;
